import React, { useEffect, useState } from 'react';
import Joyride from 'react-joyride';
import { Step, Placement } from 'react-joyride';
import dynamicMapGIF from '../../../assets/Dynamic Map Data GIF.gif';
import tailorRegionGIF from '../../../assets/Tailored Region GIF.gif';
import CustomJoyrideTooltip from 'src/App/HOC/Tooltips/CustomJoyrideTooltip';
import { COLOR_PRIMARY_2 } from 'src/colors';

const AppTour = ({ appTourStep, updateAppTourStep ,showAppTour, updateShowAppTour}) => {
  const [activeStep, setActiveStep] = useState(appTourStep);
  const [tourOpen, setTourOpen] = useState(showAppTour);
  useEffect(()=>{
    setTourOpen(showAppTour)
    setActiveStep(0)
  },[showAppTour])

  useEffect(() => {
    updateAppTourStep(activeStep);
    
    if(!showAppTour){
      updateAppTourStep(0)
    }

  }, [activeStep]);

  const handleJoyrideCallback = data => {
    if (data.action === 'close') {
      setTourOpen(false);
      setActiveStep(0);
      updateShowAppTour(false);
    }
  };
  const handleNext = () => {
    setActiveStep(prevStep => prevStep + 1);
  };
  const handleBack = () => {
    setActiveStep(prevStep => prevStep - 1);
  };

  const joyrideSteps: Step[] = [
    {
      target: '#searchTab',
      content: (
        <CustomJoyrideTooltip
          index={0}
          totalSteps={7}
          onNext={handleNext}
          onBack={handleBack}
          content="Search a city or create any markets you'd like. Draw your search area by moving and zooming
          in on the map to find your target location. Select the polygon button to draw your target
          area. Remember, we have a limit of less than 20,000 listings per market when customizing
          your search."
          title="Create Your custom Market"
          image={tailorRegionGIF}
          tutorial='https://airbtics.com/how-to-create-a-custom-market/'
        />
      ),

      placement: 'right-start',
      disableBeacon: true,
      hideCloseButton: true,
      offset: 20,
    },
    {
      target: '#map',
      content: (
        <CustomJoyrideTooltip
          index={1}
          totalSteps={7}
          onNext={handleNext}
          onBack={handleBack}
          content='Move around the map to compare multiple neighborhoods in a minute. Feel free to zoom in and out.'
          image={dynamicMapGIF}
        />
      ),
      placement: 'left',
      disableBeacon: true,
      hideCloseButton: true,
    },
    {
      target: '#kpiCards',
      content: (
        <CustomJoyrideTooltip
          index={2}
          totalSteps={7}
          onNext={handleNext}
          onBack={handleBack}
          content="These 3 data points (occupancy rate, daily rate, and revenue) change as you move around the map. This helps you to find out which location has high Airbnb demand"
          tutorial='https://airbtics.com/dynamic-data-tutorial/'
        />
      ),
      disableBeacon: true,
      hideCloseButton: true,
    },
    {
      target: '#propertySizeGraph',
      content: (
        <CustomJoyrideTooltip
          index={3}
          totalSteps={7}
          onNext={handleNext}
          onBack={handleBack}
          content="Get clear insights on high-return investment by seeing which size of properties will give you the best cash return"
        />
      ),
      disableBeacon: true,
      hideCloseButton: true,
    },
    {
      target: '#filterButton',
      content: (
        <CustomJoyrideTooltip
          index={4}
          totalSteps={7}
          onNext={handleNext}
          onBack={handleBack}
          content="Get more granular data using the advanced filter section."
        />
      ),
      disableBeacon: true,
      hideCloseButton: true,
    },
    {
      target: '#creditsBtn',
      content: (
        <CustomJoyrideTooltip
          index={5}
          totalSteps={7}
          onNext={handleNext}
          onBack={handleBack}
          content="Unlock a market by adding credits to your account. 1 credit = 1 market dashboard. Every month, you get new credits so you can explore other markets"
        />
      ),
      placement: 'bottom-end',
      disableBeacon: true,
      hideCloseButton: true,
      styles: {
        options: {
          zIndex: 999999, 
        },
        tooltip: {
          left: 80,
          maxWidth: 300,
        },
      },
    },
    {
      target: '.subscriptionModalCountryBtn',
      content: (
        <CustomJoyrideTooltip
          index={6}
          totalSteps={7}
          onNext={handleNext}
          onBack={handleBack}
          content="Do you want to explore a specific country? Avail the country plan and get unlimited access."
        />
      ),
      disableBeacon: true,
      hideCloseButton: true,
      styles: {
        options: {
          zIndex: 999999, 
        }
      },
      
    },
  ];

  const customTooltipStyles = {
    options: {
      zIndex: 9999,
    },
    tooltip: {
      backgroundColor: COLOR_PRIMARY_2,
      color: '#ffffff',
      borderRadius: '8px',
      fontSize: '16px', 
    },
    tooltipFooter: {
      display: 'none',
    },
    tooltipContent: {
      padding: '0px !important',
      margin: '0px !important'
    },
  };

  return (
    <>
      <Joyride
        steps={joyrideSteps}
        showProgress={true}
        callback={handleJoyrideCallback}
        run={tourOpen} //responsible to run the tour
        stepIndex={activeStep} //responsible for the active step
        disableScrolling={true}
        // disableScrollParentFix={true}
        hideCloseButton={true}
        styles={customTooltipStyles}
      />
    </>
  );
};

export default AppTour;
